import { signal } from "@preact/signals-react";
import { ITrackService } from "../services/trackCache";

export const trackServiceSignal = signal<ITrackService | null>(null);
